import { createAsyncThunk } from '@reduxjs/toolkit';
import * as StatusApi from '@sophocles/api/status';

export const loadStatuses = createAsyncThunk(
  'status/loadMany',
  async ({ relayControllerId, ...params }, { rejectWithValue }) => {
    try {
      const data = await StatusApi.fetchStatuses(relayControllerId, params);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

// Fetch a single status with its full payload (incl. measurements). The list
// endpoint returns a slim shape without measurements; the detail panel loads
// the full record on demand when a row is selected.
export const loadStatus = createAsyncThunk(
  'status/loadOne',
  async ({ relayControllerId, statusId }, { rejectWithValue }) => {
    try {
      return await StatusApi.fetchStatus(relayControllerId, statusId);
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
